"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M11.682 2.42L8.991.998a.64.64 0 00-.6 0L5.995 2.265 3.596.997a.64.64 0 00-.599 0L.306 2.42A.55.55 0 000 2.904v2.847c0 .2.117.386.306.483l2.397 1.262v2.524c0 .2.117.385.306.484l2.697 1.422c.185.1.415.1.6 0l2.685-1.422a.55.55 0 00.306-.484V7.495l2.397-1.261A.551.551 0 0012 5.75V2.904a.553.553 0 00-.318-.484zM1.2 5.428V3.204l2.098-1.111 2.097 1.11v2.225L3.297 6.539 1.199 5.428H1.2zm6.893 4.269l-2.098 1.111-2.098-1.111V7.472l2.098-1.11 2.098 1.111v2.224zm2.697-4.27L8.692 6.54 6.593 5.428V3.204l2.098-1.111 2.099 1.11v2.225z",
        id: "intergrations__a"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M13.682 4.42l-2.691-1.422a.64.64 0 00-.6 0L7.995 4.265 5.596 2.997a.64.64 0 00-.599 0L2.306 4.42A.55.55 0 002 4.904v2.847c0 .2.117.386.306.483l2.397 1.262v2.524c0 .2.117.385.306.484l2.697 1.422c.185.1.415.1.6 0l2.685-1.422a.55.55 0 00.306-.484V9.495l2.397-1.261A.551.551 0 0014 7.75V4.904a.553.553 0 00-.318-.484zM3.2 7.428V5.204l2.098-1.111 2.097 1.11v2.225L5.297 8.539 3.199 7.428H3.2zm6.893 4.269l-2.098 1.111-2.098-1.111V9.472l2.098-1.11 2.098 1.111v2.224zm2.697-4.27L10.692 8.54 8.593 7.428V5.204l2.098-1.111 2.099 1.11v2.225z",
        fillRule: "nonzero"
      }), (0, _jsxRuntime.jsxs)("g", {
        transform: "translate(2 2)",
        children: [(0, _jsxRuntime.jsx)("mask", {
          id: "intergrations__b",
          fill: "currentColor",
          children: (0, _jsxRuntime.jsx)("use", {
            xlinkHref: "#intergrations__a"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "currentColor",
          fillRule: "nonzero",
          mask: "url(#intergrations__b)",
          d: "M-3-1.846h18v16.615H-3z"
        })]
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Integrations.js.map